import styled from "styled-components";
import { Row } from "antd";

export default styled(Row)`
  padding: 34px 59px;

  @media only screen and (max-width: 576px) {
    padding: 10px;
  }
`